import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Table } from 'antd';
import {
  gridRequestAction,
  gridSetFilterAction,
  gridSetOrder,
  gridSetTiendaFilterAction,
} from '../../../state/actions/creators/grideable.actioncreator';

class FiltrableTable extends React.Component {
  buscar(params = {}) {
    const { gridRequestAction, endpoint, url } = this.props;
    const { pagination } = params;
    const requestObject = {
      url,
      endpoint,
    };
    if (pagination) {
      requestObject.pagination = pagination;
    }
    gridRequestAction(requestObject);
  }

  handleTableChange = (pagination) => {
    this.buscar({ pagination });
  };

  componentDidMount() {
    this.props.onRef(this);
    const { endpoint, filters } = this.props;
    if (filters !== undefined) {
      const { gridSetFilterAction } = this.props;
      gridSetFilterAction({
        endpoint,
        filters,
      });
    }
  }

  componentWillUnmount() {
    this.props.onRef(undefined);
  }

  render() {
    const { serverResponse, columns } = this.props;
    const { running, datos, pagination } = serverResponse;
    return (
      <div>
        <Table
          {...this.props}
          columns={columns}
          rowKey={record => record.id}
          onChange={this.handleTableChange}
          dataSource={datos}
          pagination={pagination}
          loading={running === true}
        />
      </div>
    );
  }
}


const mapStateToProps = (state, ownProps) => {
  const { grideable } = state;
  const { endpoint } = ownProps;
  let serverResponse = {
    running: null, success: null, datos: [], pagination: {},
  };
  if (grideable && grideable[endpoint]) {
    serverResponse = grideable[endpoint];
  }
  return {
    serverResponse,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    gridRequestAction,
    gridSetFilterAction,
    gridSetOrder,
    gridSetTiendaFilterAction,
  }, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FiltrableTable);
